exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/author-code-evaluator.js-WebpackMultiOutput";